// @flow

import { Component } from '../jsti/core';

export default class Whatsapp extends Component {
  /**
   * Initiate the component
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);
    const text = pEl.dataset.text;
    if (text) {
      this.replaceUrl(text);
    }
  }

  /**
   * Update the url to the web app of Whatsapp if on desktop
   */
  replaceUrl(text: string): void {
    const html: HTMLElement | null = document.documentElement;
    if (html) {
      const htmlClasses: DOMTokenList = html.classList;
      if (htmlClasses.contains('iphone') || htmlClasses.contains('android')) {
        return;
      }
    }

    this.el.href = `https://web.whatsapp.com/send?text=${text}`;
  }
}
